export enum DrawAddExportType {
  SHOPPINGCART = 0,
  CREATEORDER = 1,
  CHANGEORDER = 2
}
